"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paginator = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var Pagination_1 = tslib_1.__importDefault(require("react-bootstrap/Pagination"));
var Paginator = /** @class */ (function (_super) {
    tslib_1.__extends(Paginator, _super);
    function Paginator(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFirstPage = function () {
            _this.props.onChange(1);
        };
        _this.handlePreviousPage = function () {
            _this.props.onChange(_this.props.currentPage - 1);
        };
        _this.handleNextPage = function () {
            _this.props.onChange(_this.props.currentPage + 1);
        };
        _this.handleLastPage = function () {
            _this.props.onChange(_this.state.pageCount);
        };
        _this.state = {
            pageCount: Math.round(_this.props.totalCount / _this.props.perPage) +
                (_this.props.totalCount % _this.props.perPage ? 1 : 0),
        };
        return _this;
    }
    Paginator.prototype.render = function () {
        return (react_1.default.createElement(Pagination_1.default, null,
            react_1.default.createElement(Pagination_1.default.First, { onClick: this.handleFirstPage, disabled: this.props.currentPage === 1 }),
            react_1.default.createElement(Pagination_1.default.Prev, { onClick: this.handlePreviousPage, disabled: this.props.currentPage === 1 }),
            this.renderPagination(),
            react_1.default.createElement(Pagination_1.default.Next, { onClick: this.handleNextPage, disabled: this.props.currentPage === this.state.pageCount }),
            react_1.default.createElement(Pagination_1.default.Last, { onClick: this.handleLastPage, disabled: this.props.currentPage === this.state.pageCount })));
    };
    Paginator.prototype.renderPagination = function () {
        var items = [];
        var pageCount = this.state.pageCount || 0;
        var pageRangeDisplayed = this.props.pageRangeDisplayed || 2;
        var marginPagesDisplayed = this.props.marginPagesDisplayed || 3;
        if (pageCount <= pageRangeDisplayed) {
            for (var index_1 = 0; index_1 < pageCount; index_1++) {
                items.push(this.renderPageLink(index_1 + 1));
            }
            return items;
        }
        var leftSide = pageRangeDisplayed / 2;
        var rightSide = pageRangeDisplayed - leftSide;
        // If the selected page index is on the default right side of the pagination,
        // we consider that the new right side is made up of it (= only one break element).
        // If the selected page index is on the default left side of the pagination,
        // we consider that the new left side is made up of it (= only one break element).
        if (this.props.currentPage > pageCount - pageRangeDisplayed / 2) {
            rightSide = pageCount - this.props.currentPage;
            leftSide = pageRangeDisplayed - rightSide;
        }
        else if (this.props.currentPage < pageRangeDisplayed / 2) {
            leftSide = this.props.currentPage;
            rightSide = pageRangeDisplayed - leftSide;
        }
        var index;
        var page;
        var breakView;
        for (index = 0; index < pageCount; index++) {
            page = index + 1;
            // If the page index is lower than the margin defined,
            // the page has to be displayed on the left side of
            // the pagination.
            if (page <= marginPagesDisplayed) {
                items.push(this.renderPageLink(page));
                continue;
            }
            // If the page index is greater than the page count
            // minus the margin defined, the page has to be
            // displayed on the right side of the pagination.
            if (page > pageCount - marginPagesDisplayed) {
                items.push(this.renderPageLink(page));
                continue;
            }
            // If the page index is near the selected page index
            // and inside the defined range (pageRangeDisplayed)
            // we have to display it (it will create the center
            // part of the pagination).
            if (index >= this.props.currentPage - leftSide &&
                index <= this.props.currentPage + rightSide) {
                items.push(this.renderPageLink(page));
                continue;
            }
            // If the page index doesn't meet any of the conditions above,
            // we check if the last item of the current "items" array
            // is a break element. If not, we add a break element, else,
            // we do nothing (because we don't want to display the page).
            if (items[items.length - 1] !== breakView) {
                breakView = react_1.default.createElement(Pagination_1.default.Ellipsis, null);
                items.push(breakView);
            }
        }
        return items;
    };
    Paginator.prototype.renderPageLink = function (page) {
        var _this = this;
        return (react_1.default.createElement(Pagination_1.default.Item, { key: page, active: this.props.currentPage === page, onClick: function () { return _this.props.onChange(page); } }, page));
    };
    return Paginator;
}(react_1.PureComponent));
exports.Paginator = Paginator;
//# sourceMappingURL=Paginator.js.map